module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-grid/incrementdetails-grid.component.css
// module id = ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-grid/incrementdetails-grid.component.css
// module chunks = main